import { Component, ViewChild } from '@angular/core';
import { ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { FormBuilder } from '@angular/forms';
import { Globals } from "../../../../globals";
import { ConfigurationServices } from "../../services";
import { TranslateService } from '@ngx-translate/core';
import { ModalRatings } from '../../../components/modal-ratings/modal-ratings';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * Generated class for the ConfigurationTicketsRatingsListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-configuration-tickets-ratings-list',
  templateUrl: 'configuration-tickets-ratings-list.html',
})
export class ConfigurationTicketsRatingsListPage {

  list_rating: any;
  //datatable
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public fb: FormBuilder,
    public configurationServices: ConfigurationServices,
    public globals: Globals,
    public translate: TranslateService,
    public modalCtrl: ModalController,
    public http: HttpClient,
    public toastCtrl: ToastController) {

  }

  ionViewWillEnter() {
    this.getListRating();
  }

  openModalRatings(event) {
    if (event.type == 'click') {
      if (event.row.reply == '' && event.row.state != 'seen') {
        var index_rating = this.list_rating.findIndex(x => x.UID == event.row.UID);
        this.list_rating[index_rating].state = 'seen';
        this.configurationServices.afs.collection('restaurants/' + this.globals.restaurant_uid + '/ratings').doc(event.row.UID).update({
          'state': 'seen',
        }).then(() => { });
      }
      let profileModal = this.modalCtrl.create(ModalRatings, {
        rating: event.row,
        ratings: this.list_rating,
      });
      profileModal.onDidDismiss(data => {
      });
      profileModal.present();
    }
  }

  async updateRatingsInShare(ratings_in_share) {
    this.globals.restaurant.ratings_in_share = ratings_in_share;
    await this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'ratings_in_share': ratings_in_share,
    });
    let toast = this.toastCtrl.create({
      message: this.translate.instant('general-guardado-correctamente'),
      duration: 1500,
      position: 'top'
    });
    toast.present();
  }

  get_ratings_complete = false;
  async getListRating() {
    this.list_rating = [];
    const params = new HttpParams()
      .set('public_key', this.globals.public_key);

    await this.http.post(this.globals.analytics_path + 'get_restaurant_ratings', params, {})
      .subscribe(async res => {
        this.list_rating = res;
        this.get_ratings_complete = true;
      });
  }

}



// WEBPACK FOOTER //
// ./src/pages/configuration/configuration-tickets/configuration-tickets-ratings-list/configuration-tickets-ratings-list.ts